<is-wait-message [loadComplete]="!apiCallInProgress()" [useBolt]="false" [waitMessage]="'Please wait while we process your request.'" [timeoutAmount]="0"></is-wait-message>
<div class="bolt-container">
  <bw-bolt-progress-bar appFocusOnInit arialabel="edit payment plan progress value is 30%" class="progress-bar-container to-container" progressBarValue="30"></bw-bolt-progress-bar>
  <h1 class="bolt-heading-primary bolt-space-bottom-2xl">Payment plan: select</h1>

  <strong>Billing account #</strong>: {{ billingAccountNumber() }}
  <br />
  <strong>Policy type</strong>: {{ agreementType }}
  <br />
  <strong>Policy number</strong>: {{ policyNumber() }}
  <br />
  <br />

  <div class="bolt-row">
    <div class="bolt-col-6">
      <div class="card-header">
        <h3 class="bold">Current plan</h3>
      </div>
      <div [ngClass]="payCardType() == 'month' ? 'selected-card bolt-background-vibrantBlue' : 'card bolt-background-white'">
        <h4 class="bold">Monthly pay plan</h4>
        <p class="selected-premium">{{ amountDue | currency: 'USD' }}</p>
        @if (showEmptyBillResponse()) {
          <div>
            <br />
          </div>
        }
        <p class="description">{{ monthPayDescription }}</p>
        <br />
        <div class="bolt-row">
          <div class="btn-bg-style">
            @if (payCardType() != 'month') {
              <bolt-button (click)="onMonthPaySelected()">Select</bolt-button>
            } @else {
              <bolt-button iconleft="checkmark" type="ghost" color="white" (click)="onMonthPaySelected()">Selected</bolt-button>
            }
          </div>
        </div>
      </div>
    </div>
    <div class="bolt-col-6">
      <div class="empty-header"></div>
      <div [ngClass]="payCardType() == 'full' ? 'selected-card bolt-background-vibrantBlue' : 'card bolt-background-white'">
        <h4 class="bold">Full pay plan</h4>
        <p class="selected-premium">{{ premium | currency: 'USD' }}</p>
        <p class="description">{{ fullPayDescription }}</p>
        <div class="bolt-row">
          <div class="btn-bg-style">
            @if (payCardType() != 'full') {
              <bolt-button (click)="onFullPaySelected()">Select</bolt-button>
            } @else {
              <bolt-button iconleft="checkmark" type="ghost" color="white" (click)="onFullPaySelected()">Selected</bolt-button>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
  <br />
  @if (payCardType() == 'full') {
    <bw-bolt-notification type="info" class="bolt-space-bottom-2xl to-container">
      <is-interpolate [text]="infoText"></is-interpolate>
    </bw-bolt-notification>
    <bolt-checkbox [attr.invalid]="disAgreedError() ? true : null" ngDefaultControl value="agree" required (change)="onAgreeChanged($event)">{{ agreementText }}</bolt-checkbox>
  }
  @if (disAgreedError()) {
    <app-form-control-error id="esdda-checkbox-error">Please acknowledge your changes.</app-form-control-error>
  }
  <br />
</div>
<bolt-button-bar>
  <bolt-button (click)="cancelEditPaymentPlan()" slot="cancel" id="cancel-button">Cancel</bolt-button>
  <bolt-button submit slot="forward" type="solid" id="continue-button" [disabled]="payCardType() == 'month'" (click)="onSubmit()">Submit</bolt-button>
</bolt-button-bar>
